import { getDiscountValue } from '../../../utils/price';
import { readCookie } from '../../../components/common/Cookie';
import { getStoreName } from '../../../modules/ga/GTMdatalayer';

const sortProductList = products => {
  if (products)
    for (const x in products)
      products[x].inStockFlag == false ? products.push(products.splice(x, 1)[0]) : 0;
  return products;
};

const getProductIds = banner => {
  let productIds = '';
  banner?.products?.forEach(({ productId }) => {
    productIds = `${productIds}${productIds ? ',' : ''}${productId}`;
  });
  return productIds;
};

const getBannerName = (banner = {}) => {
  const { bannerUrl = '' } = banner;
  const bannerNameWithExt = bannerUrl?.split('/')?.pop();
  return bannerNameWithExt?.split('.')[0];
};

const getProductsArray = (products, currentBannerMediaType = 'IMAGE') => {
  return products.map((product = {}, index) => {
    const {
      name,
      price: { value: productPrice = '' } = {},
      wasPriceData: { value: wasProductPrice } = {},
      code = '',
      fnlColorVariantData: { brandName = '', colorGroup = '' } = {},
      fnlProductData: { planningCategory = '' } = {},
      discountPercent = '',
      segmentId = '',
      experimentId = ''
    } = product;
    const discount =
      Number.isInteger(wasProductPrice) && Number.isInteger(productPrice)
        ? wasProductPrice - productPrice
        : '';
    const colorValue =
      colorGroup && colorGroup?.includes('_') ? colorGroup.split('_')[1] || '' : colorGroup;
    const dimension60Data =
      Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
    return {
      name,
      id: code,
      price: productPrice,
      brand: brandName,
      category: planningCategory,
      variant: colorValue,
      list: currentBannerMediaType === 'IMAGE' ? 'shop the look' : 'shop the look video',
      position: index,
      dimension12: code,
      dimension13: name,
      dimension14: '',
      dimension15: planningCategory,
      dimension16: planningCategory,
      dimension20: '',
      dimension21: brandName,
      dimension22: productPrice,
      dimension23: getStoreName(),
      dimension24: '',
      dimension60: dimension60Data,
      dimension170: getDiscountValue(discountPercent)
    };
  });
};

export { getProductIds, getBannerName, getProductsArray, sortProductList };
